<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@managePlans">Manage Plans</div>
  <div i18n="@@choosePlanOrExtend">Choose plan or extend free trial</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="managePlanForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label i18n="@@planLabel">Plan</mat-label>
      <mat-select [value]="currentPlan" data-testid="plan" (selectionChange)="planChange($event)" formControlName="plan" id="plan" i18n-placeholder="@@planPlaceholder" placeholder="Plan" matNativeControl>
        <mat-option i18n="@@Free" [value]="1">Free</mat-option>
        <mat-option i18n="@@Lite" [value]="2">Lite</mat-option>
        <mat-option i18n="@@Bronze" [value]="3">Bronze</mat-option>
        <mat-option i18n="@@Silver" [value]="4">Silver</mat-option>
        <mat-option i18n="@@Gold" [value]="5">Gold</mat-option>
        <mat-option i18n="@@Platinium" [value]="6">Platinium</mat-option>
        <mat-option i18n="@@Diamond" [value]="7">Diamond</mat-option>
        <mat-option i18n="@@Titanium" [value]="8">Titanium</mat-option>
      </mat-select>
    </mat-form-field>
    <div>
      @if (currentPlan === 1) {
        <button i18n="@@extend" data-testid="extend_plan" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Extend</button>
      }
      @if (currentPlan !== 1) {
        <button i18n="@@change" data-testid="change_plan" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Change</button>
      }
    </div>
  </form>
</mat-dialog-content>
